/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_ButtonInputs */

const en_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Metadata`)
};

const fr_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les métadonnées`)
};

const de_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten speichern`)
};

const it_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva metadati`)
};

const ru_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить метаданные`)
};

const es_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar metadatos`)
};

const zh_cn2_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存元数据`)
};

const ja_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータを保存`)
};

const hi_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा सहेजें`)
};

const pt_pt2_event_group_metadata_save_button = /** @type {(inputs: Event_Group_Metadata_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar metadados`)
};

/**
* | output |
* | --- |
* | "Save Metadata" |
*
* @param {Event_Group_Metadata_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_button = /** @type {((inputs?: Event_Group_Metadata_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_save_button(inputs)
	if (locale === "de") return de_event_group_metadata_save_button(inputs)
	if (locale === "it") return it_event_group_metadata_save_button(inputs)
	if (locale === "ru") return ru_event_group_metadata_save_button(inputs)
	if (locale === "es") return es_event_group_metadata_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_save_button(inputs)
	if (locale === "ja") return ja_event_group_metadata_save_button(inputs)
	if (locale === "hi") return hi_event_group_metadata_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_save_button(inputs)
	return en_event_group_metadata_save_button(inputs)
});